export default __webpack_public_path__ + "static/media/015-cuckoo clock.f666f37e.svg";